import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from 'rxjs/Rx';

@Injectable()
export class SfPayPeriodsProvider {
    private _service: string = 'payroll';
    private _model: string = 'SFPayPeriods';

    constructor(private nestApiProvider: NestApiProvider) { }

    public getPeriod(periodCode: any = {}): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'getPeriod';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
    }

    public newSchedule2(params: any): Observable<any> {
        const _method: string = 'POST';
        const _func: string = 'newSchedule2';
        const _params: any = params || {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
    }

    public delPastPayroll(params: any): Observable<any> {
        const _method: string = 'POST';
        const _func: string = 'delPastPayroll';
        const _params: any = params || {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
    }

    public getPayment(): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'getPayment';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
    }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payperiods/sf-payperiods.ts